import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";
import NoGapContentpoints from "../../Components/sub-pages/NoGapContent_point";
import DynamicFaqs from "../../Components/home/Faqs";

const WomensDay =()=>{

    const CTAContent = [
        {
          pageName: "Womens Day Gifting",
          paragraphitalic: "Women's Day Gifts That Celebrate Appreciation, Inclusion, and Workplace Culture ",
          paragraphText:
            "At eYantra, corporate gifting is not just a service. It is a thoughtfully designed experience that aligns with your company’s culture and values. Our Women’s Day gifts are created with purpose, designed to make every employee, client, or partner feel valued. From premium hampers to personalised stationery, lifestyle kits, accessories, and sustainable gifting options, our collections ensure your Women’s Day celebration becomes memorable and meaningful.",
          ContactFormName: "Womens day Gifting",
        },
      ];
    
      const SubpgesLeftContent = [
        {
          index: 0,
          sectionName: "The Importance of Women's Day Corporate Gifts ",
          parapgraphItalic: "",
          sectionparagraphText: (
            <>
              <p>
               Women's Day gifting has become an essential part of internal employee engagement programs and corporate celebration culture. It strengthens connections and communicates gratitude in a personal, yet professional way. Here are a few reasons why companies prioritise thoughtful Women's Day gifting:
              </p>
            </>
          ),
          ImgSrc: "../assests/images/experiential gifting/Custom Gifting.jpg",
        },
        /**Catagory Img */
        {
          index: 1,
          sectionName: "Women's Day Corporate Gifts That Create Impact ",
          parapgraphItalic: "",
          sectionparagraphText: (
            <>
              <p>
                Corporate gifting should balance utility, aesthetics, and personalisation. Over the years, we have curated and delivered corporate Women’s Day gifts for thousands of employees across India. Based on this experience, here are some categories that stand out and create maximum impact.
              </p>
            </>
          ),
          ImgSrc: "../assests/images/experiential gifting/Innovative Designs.jpg",
          categoryHeadingLeftSide: "What we create?",
          CategoriesLeftContent: [
            {
              CategoryImg: "../assests/images/Womens-day-gifting/Premium Women's day gift hampers.jpg",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Premium Women's Day Gift Hampers</b> <br></br>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Womens-day-gifting/Personolised Womens's Day gifts.png",
              CategoryName: <>
              <p className="fs-14">
                <b>Personalised Women's Day Gifts</b> <br></br>
              </p>
            </>,
            },
            {
              CategoryImg: "../assests/images/Womens-day-gifting/Women's day office gifts.jpg",
              CategoryName: <>
              <p className="fs-14">
                <b>Women's Day Office Gifts</b> <br></br>
              </p>
              </>,
            },
          ],
        },
        {
          index: 1,
          sectionName: "Popular Women’s Day Gift Ideas to Consider",
          parapgraphItalic: "",
          sectionparagraphText: (
            <>
              <p>
                If you are planning your corporate Women’s Day gifting, here are some ideas based on what companies across industries prefer
              </p>
            </>
          ),
          ImgSrc: "../assests/images/experiential gifting/Innovative Designs.jpg",
          categoryHeadingLeftSide: "Gift Ideas",
          CategoriesLeftContent: [
            {
              CategoryImg: "../assests/images/Womens-day-gifting/Spa and wellness hampers.png",
              CategoryName: (
                <>
                  <p className="fs-14">
                    <b>Spa and wellness hampers </b> <br></br>
                  </p>
                </>
              ),
            },
            {
              CategoryImg: "../assests/images/Womens-day-gifting/Minimalist Jewellery or accessories.png",
              CategoryName: <>
              <p className="fs-14">
                <b>Minimalist jewellery or accessories</b> <br></br>
              </p>
            </>,
            },
            {
              CategoryImg: "../assests/images/Womens-day-gifting/Self care and relaxation sets.png",
              CategoryName: <>
              <p className="fs-14">
                <b>Self-care and relaxation sets </b> <br></br>
              </p>
              </>,
            },
          ],
        },
      ];
      const noGapContent = [
        //added
        {
          RightImgNogap: "../assests/images/experiential gifting/What we create.jpg",
          NogapHeading: "What We Offer?",
          Heading: [
            {
              ListHeading: "Appreciation and Recognition",
              ListParagraph: "Corporate Women's Day gifts help organisations express appreciation for the hard work, dedication, and leadership shown by women across functions.",
            },
            {
              ListHeading: "Encouraging a Positive Workplace",
              ListParagraph: "Meaningful gifting fosters inclusivity and sends a message that the organisation cares about creating a balanced and empowered workspace.",
            },
            {
              ListHeading: "Strengthening Company Culture",
              ListParagraph: "Gifts can reflect your organisation’s identity. Whether you choose eco-friendly kits, luxury hampers, or personalised accessories, your choices can communicate what your company values.",
            },
            {
              ListHeading: "Enhancing Employer Branding ",
              ListParagraph: "Employees remember thoughtful gestures. A well-curated Women’s Day gifting program contributes to strong internal branding and employee retention. ",
            },
          ],
        },
          {
            RightImgNogap: "../assests/images/experiential gifting/Seamless Delivery.jpg",
            NogapHeading: "How eYantra Helps You With Women's Day Corporate Gifts",
            paragraphItalic:"",
            paragraphDetail:(
              <>
                <p>
                  eYantra is India's leading corporate gifting partner with over years of experience delivering customised gifting solutions to brands across industries. Our Women’s Day gifting services include
                </p>
              </>
            ),
            
            NogapSubheading:"What we offer?",
            Categories: [
              {
                ServiceImg: "../assests/images/Womens-day-gifting/Curated Women's day gift collections.jpg",
                ServiceText: (
                  <>
                    <p className="fs-14">
                      <b>Curated Women's Day Gift Collections</b> 
                    </p>
                  </>
                ),
              },
              {
                ServiceImg: "../assests/images/Womens-day-gifting/Customisation and branding.png",
                ServiceText: (
                  <>
                    <p className="fs-14">
                      <b>Customisation and Branding </b> 
                    </p>
                  </>
                ),
              },
              {
                ServiceImg: "../assests/images/experiential gifting/Timely Delivery.png",
                ServiceText: (
                  <>
                    <p className="fs-14">
                      <b>Bulk and Pan India Delivery</b>
                    </p>
                  </>
                ),
              },
            ],
            
        
        },
        {
            RightImgNogap: "../assests/images/Womens-day-gifting/Choosing the Right Women's day gifts for your team.jpg",
            NogapHeading: "Choosing the Right Women's Day Gifts for Your Team ",
            paragraphItalic:"",
            paragraphDetail:(
              <>
                <p>
                  The right gift depends on your team's preferences, your organisational culture, and your gifting goals. Here are some considerations
                </p>
              </>
            ),
            
            NogapSubheading:"Tips for Choosing the Right Gifts",
            Categories: [
              {
                ServiceImg: "../assests/images/Womens-day-gifting/Identity what employees will value.png",
                ServiceText: (
                  <>
                    <p className="fs-14">
                      <b>Identify what employees will value</b> 
                    </p>
                  </>
                ),
              },
              {
                ServiceImg: "../assests/images/experiential gifting/Quality Assurance.png",
                ServiceText: (
                  <>
                    <p className="fs-14">
                      <b>Offer personalisation where possible</b> 
                    </p>
                  </>
                ),
              },
              {
                ServiceImg: "../assests/images/Womens-day-gifting/Plan gifting timelines in advance.png",
                ServiceText: (
                  <>
                    <p className="fs-14">
                      <b>Plan gifting timelines in advance</b>
                    </p>
                  </>
                ),
              },
            ],
            
        
        },
    
        /**new index */
        {
          RightImgNogap: "../assests/images/sub-pages/IMG-5.png",
          NogapHeading: "Milestone Recognition ",
          paragraphItalic: "Make sure every gift reflects excellence.",
          paragraphDetail: (
            <>
              <p>
              Appreciate dedication and achievements. 
              </p>
              <p>
                Show appreciation for the hard work and dedication that goes into every achievement. 
              </p>
              <p>
              Milestones such as work anniversaries, project completions, and promotions deserve to be celebrated. At eYantra, we provide a range of premium milestone gifts that are as unique as the achievements. 
              </p>
            </>
          ),
    
          NogapSubheading: "Our Milestone Gift Options Include:",
          Categories: [
            {
              ServiceImg: "../assests/images/sub-pages/logo-printing.png",
              ServiceText: (
                <>
                     
                    <p className="fs-14">
                    <b>Personalized Awards</b>
                  </p>
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/sub-pages/engraving.png",
              ServiceText: (
                <>
                <p className="fs-14">
                    <b>Luxury Gift Hampers</b> 
                  </p>
                     
                </>
              ),
            },
            {
              ServiceImg: "../assests/images/sub-pages/color-matching.png",
              ServiceText: (
                <>
                    <p className="fs-14">
                    <b>Luxury Gift Hampers</b>
                  </p>
    
                </>
              ),
            },
          ],
        },
      ];
     
      const NoGapContentPoints = [
        {
          RightImgNogap: "../assests/images/sub-pages/IMG-4.png",
          NogapHeading: "Why Personalisation Matters in Women's Day Corporate Gifting ",
          Sectionparagraph:"When it comes to Women’s Day gifts, personalisation transforms a regular gift into a memorable experience. Adding a name, engraving initials, or creating custom packaging communicates attention to detail and heartfelt appreciation. Organisations increasingly prefer personalised Women's Day gifts because",
          Heading: [
            {
              ListHeading: "They increase emotional connection",
              ListParagraph: "",
            },
            {
              ListHeading: "They reflect thoughtful gifting ",
              ListParagraph:
                "",
            },
            {
              ListHeading: "They elevate the gifting experience ",
              ListParagraph:
                "",
            },
            {
              ListHeading: "They reinforce the organisation’s brand identity ",
              ListParagraph:
                "",
            },
            {
              ListHeading: "They provide long-term utility",
              ListParagraph:
                "",
            }
          ],
        
        },
      ];

      const faqsData = [
  {
    question: "What are the best Women’s Day gifts for employees?",
    answer:
      "Popular options include personalised stationery, wellness hampers, office essentials, self-care kits, and eco-friendly products.",
  },
  {
    question: "Can Women’s Day corporate gifts be customised?",
    answer:
      "Yes, almost all gifts can be customised with logos, employee names, brand colours, and personalised packaging.",
  },
  {
    question: "What is the ideal budget for Women’s Day corporate gifts?",
    answer:
      "Budgets usually range from economical to premium, depending on the gift type. We offer customised solutions for all budgets.",
  },
  {
    question: "Do you provide Women’s Day gifts in bulk?",
    answer:
      "Yes, we specialise in bulk gifting with timely delivery across India.",
  },
  {
    question: "What are some premium Women’s Day corporate gifting options?",
    answer:
      "You can choose luxury hampers, premium accessories, branded merchandise, high quality stationery, or elegant desk decor pieces.",
  },
  {
    question: "Can gifts be delivered to multiple office locations?",
    answer:
      "Yes, we offer pan India multi-location deliveries.",
  },
  {
    question: "Do you offer eco-friendly Women’s Day gifts?",
    answer:
      "Yes, we provide sustainable options such as plantable stationery, bamboo products, recycled accessories, and more.",
  },
  {
    question: "Can you create a customised Women’s Day gift box for our company?",
    answer:
      "Yes, we curate and design personalized gift boxes with your preferred theme, colours, and branding.",
  },
  {
    question: "When should companies start planning Women’s Day gifting?",
    answer:
      "It is ideal to start planning two to three weeks in advance to ensure proper personalisation and smooth delivery.",
  },
];


  
    return(
        <>
            <Helmet>
        <title>Women's Day Gifts and Premium Women's Day Corporate Gifting Solutions</title>
        <meta name="description" content="Discover premium Women's Day gifts and personalized corporate gifting solutions for employees, clients, and colleagues. Thoughtfully curated hampers, customized merchandise, and exclusive Women's Day gift ideas for organizations."/>
        <meta name="keyword" content="Women’s day gifts, women’s day corporate gifts, corporate gifts for women’s day, women’s day gifts for employees, women’s day gift hampers, personalized women’s day gifts, women’s day office gifts, bulk women’s day gifts, women’s day gifting ideas, women’s day celebration gifts, women’s day gifts for colleagues, premium women’s day corporate gifts, customized women’s day gifts, women’s day gift ideas for staff, women’s day appreciation gifts, corporate women’s day merchandise"/>
        </Helmet>
        <div className="p-0 m-2">
        <Ctapage data={CTAContent} />
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      </Container>
      <NogapleftImg data={noGapContent[0]}/>
      <Container>
        <LeftContentRightImg data={SubpgesLeftContent[1]} />
      </Container>
      <NogapleftImg data={noGapContent[1]}/> 
      
      <NoGapContentpoints data={NoGapContentPoints[0]}/>
       <LeftContentRightImg data={SubpgesLeftContent[2]} />
      
      <NogapleftImg data={noGapContent[2]}/> 

      </div>
      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Let us help you craft unforgettable experiences for employees, clients, event attendees, and more. 
      </p>

        <Container className="py-5">
        <h2>Frequently Asked Questions</h2>
      <DynamicFaqs faqsDynamicContent={faqsData} />
      </Container>

        </>
    )
}

export default WomensDay;